import MailRu from './MailRu'

export default MailRu
// eslint-disable-next-line import/export
export * from './MailRu'
